import React from "react";
import { SettlementBreakdownComponent } from "../billing/settlement/breakdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSettlements } from "../../redux/modules/settlement";
import { getById } from "../../redux/restdux/utils";
import { withRouter } from "react-router";

export const EstateSettlementModalComponent = ({
  settlements,
  match,
  onClose,
}) => {
  const settlement = getById(match.params.settleId, settlements);
  if (!settlement) {
    return null;
  }
  return (
    <SettlementBreakdownComponent settlement={settlement} onClose={onClose} />
  );
};

const mapStateToProps = (state, ownProps) => {
  const onClose = () => {
    ownProps.history.replace(ownProps.returnURL);
  };
  return {
    settlements: state.settlement.entities,
    onClose,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchSettlements }, dispatch);
};

export const SettlementModal = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EstateSettlementModalComponent)
);
